import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";
import { iniciarCanarioDeGlifos } from "./components/ds/dev-glyph-canary";

// Avisa por consola si algún ícono quedó fuera de la fuente subseteada y se
// está dibujando como texto. No hace nada fuera de desarrollo.
iniciarCanarioDeGlifos();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
